import { toast } from 'react-toastify';

// Success toast notification
export const showSuccessToast = (message) => {
    toast.success(message, {
      position: 'top-right',
      autoClose: 3000,
    });
  };

// Error toast notification
export const showErrorToast = (message) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 3000,
    });
  };
